'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var utilities = require('@brandfolder/utilities');
var classnames = require('classnames');
var React = require('react');
require('../../../../enums/accordion.js');
require('../../../../enums/alert.js');
require('../../../../enums/avatar.js');
require('../../../../enums/breakpoints.js');
var button = require('../../../../enums/button.js');
require('../../../../enums/code-editor.js');
require('../../../../enums/colors.js');
require('../../../../enums/combobox.js');
require('../../../../enums/date.js');
require('../../../../enums/drag-and-drop.js');
require('../../../../enums/dialog.js');
require('../../../../enums/divider.js');
require('../../../../enums/dropdown.js');
require('../../../../enums/fieldset.js');
require('../../../../enums/font-icon.js');
require('../../../../enums/fonts.js');
require('../../../../enums/headings.js');
require('../../../../enums/input.js');
require('../../../../enums/keys.js');
require('../../../../enums/list.js');
require('../../../../enums/listbox.js');
require('../../../../enums/loader.js');
require('../../../../enums/margin.js');
require('../../../../enums/option.js');
require('../../../../enums/pill.js');
require('../../../../enums/placements.js');
require('../../../../enums/popout.js');
require('../../../../enums/privacy.js');
require('../../../../enums/radio-group.js');
require('../../../../enums/status.js');
require('../../../../enums/switch.js');
require('../../../../enums/table.js');
require('../../../../enums/tooltip.js');
require('../../../../enums/transitions.js');
require('../../../../enums/widths.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var classnames__default = /*#__PURE__*/_interopDefaultCompat(classnames);
var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const BaseButton = /*#__PURE__*/ React.forwardRef((props, ref)=>{
    const { 'aria-disabled': ariaDisabled , className , disabled , loading , onClick , type ='button' , variant =button.ButtonVariants.None , ...otherProps } = props;
    const isDisabled = utilities.getBooleanishTruthy(ariaDisabled) || disabled || loading || undefined;
    /**
   * <form> with a <button type="submit"> still submits with aria-disabled="true",
   * actual disabled attribute is needed in this situation
   * */ const submitDisabled = type === 'submit' && isDisabled;
    return /*#__PURE__*/ React__default.default.createElement("button", _extends({}, otherProps, {
        "aria-disabled": isDisabled,
        className: classnames__default.default({
            'bf-button': true,
            [`bf-button__${variant}`]: variant !== button.ButtonVariants.None,
            [`${className}`]: !!className
        }),
        disabled: submitDisabled,
        ref: ref,
        onClick: isDisabled ? undefined : onClick,
        type: type
    }));
});

exports.BaseButton = BaseButton;
//# sourceMappingURL=base-button.js.map
